import React, { useMemo, useState } from 'react';
import Button from '../UI/Button';

export default function JobFilters({ filters, onFilterChange, onClear }) {
	const [local, setLocal] = useState(filters);

	function toggleArray(key, value) {
		setLocal((f) => {
			const arr = new Set(f[key] || []);
			if (arr.has(value)) arr.delete(value);
			else arr.add(value);
			return { ...f, [key]: Array.from(arr) };
		});
	}

	function setField(key, value) {
		setLocal((f) => ({ ...f, [key]: value }));
	}

	function apply() {
		onFilterChange?.(local);
	}

	const activeCount = useMemo(() => {
		let c = 0;
		if ((local.experienceLevel || []).length) c += 1;
		if ((local.employmentType || []).length) c += 1;
		if (local.locationType) c += 1;
		if (local.salaryMin || local.salaryMax) c += 1;
		if (local.datePosted && local.datePosted !== 'any') c += 1;
		return c;
	}, [local]);

	return (
		<div className="border rounded-lg p-4 bg-white">
			<div className="flex items-center justify-between">
				<h3 className="font-semibold">Filters</h3>
				{activeCount > 0 && <span className="text-xs bg-gray-100 px-2 py-0.5 rounded">{activeCount}</span>}
			</div>
			<div className="mt-3 space-y-4">
				<section>
					<p className="text-sm font-medium">Experience Level</p>
					<div className="mt-1 grid grid-cols-2 gap-1 text-sm">
						<label className="flex items-center gap-2">
							<input type="checkbox" checked={local.experienceLevel?.includes('entry')} onChange={() => toggleArray('experienceLevel', 'entry')} /> Entry Level
						</label>
						<label className="flex items-center gap-2">
							<input type="checkbox" checked={local.experienceLevel?.includes('mid')} onChange={() => toggleArray('experienceLevel', 'mid')} /> Mid Level
						</label>
						<label className="flex items-center gap-2">
							<input type="checkbox" checked={local.experienceLevel?.includes('senior')} onChange={() => toggleArray('experienceLevel', 'senior')} /> Senior
						</label>
						<label className="flex items-center gap-2">
							<input type="checkbox" checked={local.experienceLevel?.includes('lead')} onChange={() => toggleArray('experienceLevel', 'lead')} /> Lead/Executive
						</label>
					</div>
				</section>
				<section>
					<p className="text-sm font-medium">Employment Type</p>
					<div className="mt-1 grid grid-cols-2 gap-1 text-sm">
						{['full-time', 'part-time', 'contract', 'internship'].map((t) => (
							<label key={t} className="flex items-center gap-2">
								<input type="checkbox" checked={local.employmentType?.includes(t)} onChange={() => toggleArray('employmentType', t)} /> {t.replace('-', ' ')}
							</label>
						))}
					</div>
				</section>
				<section>
					<p className="text-sm font-medium">Location Type</p>
					<div className="mt-1 grid grid-cols-3 gap-1 text-sm">
						{['remote', 'onsite', 'hybrid'].map((t) => (
							<label key={t} className="flex items-center gap-2">
								<input type="radio" name="locationType" checked={local.locationType === t} onChange={() => setField('locationType', t)} /> {t}
							</label>
						))}
					</div>
				</section>
				<section>
					<p className="text-sm font-medium">Salary Range</p>
					<div className="mt-1 grid grid-cols-2 gap-2">
						<input className="border rounded px-2 py-1 text-sm" type="number" placeholder="Min" value={local.salaryMin || ''} onChange={(e) => setField('salaryMin', Number(e.target.value) || 0)} />
						<input className="border rounded px-2 py-1 text-sm" type="number" placeholder="Max" value={local.salaryMax || ''} onChange={(e) => setField('salaryMax', Number(e.target.value) || 0)} />
					</div>
				</section>
				<section>
					<p className="text-sm font-medium">Date Posted</p>
					<select className="border rounded px-2 py-1 text-sm mt-1" value={local.datePosted || 'any'} onChange={(e) => setField('datePosted', e.target.value)}>
						<option value="any">Any time</option>
						<option value="24h">Last 24 hours</option>
						<option value="7d">Last 7 days</option>
						<option value="30d">Last 30 days</option>
					</select>
				</section>
			</div>
			<div className="mt-3 flex items-center justify-between">
				<Button variant="ghost" onClick={onClear}>
					Clear Filters
				</Button>
				<Button onClick={apply}>Apply Filters</Button>
			</div>
		</div>
	);
}


